"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const NoEdit = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.58 5.338L3.167 6.75l5.37 5.37-3.099 3.097a1 1 0 00-.242.391L3.82 19.74a.5.5 0 00.632.632l4.13-1.376a1 1 0 00.392-.242l3.098-3.098 6.183 6.183 1.413-1.412L4.58 5.338zm10.319 7.49l3.1-3.1-3.535-3.536-3.101 3.1 3.536 3.536zm3.1-8.757a1 1 0 00-1.414 0L15.17 5.485l3.535 3.535 1.414-1.414a1 1 0 000-1.414L18 4.071z"
      }
    )
  );
};
export default NoEdit;
